export default __webpack_public_path__ + "static/media/stadium.52faa52c.png";